/** Icons of the operational map page (prototype of 24/10, proposed to the DS §08 with the
 *  registro · I-51): panel sections, drawing tools, framing. Same set as the rest (outline, grid
 *  24, stroke 1.7, never filled); `Icon` merges every file. */
export const MAP_PATHS = {
  layers: (
    <>
      <path d="M12 3.6 21 8.4 12 13.2 3 8.4Z" />
      <path d="M3 12.4 12 17.2 21 12.4" />
      <path d="M3 16.2 12 21 21 16.2" />
    </>
  ),
  pencil: (
    <>
      <path d="M4.2 19.8 5.2 15.2 15.6 4.8a2 2 0 0 1 2.8 0l.8.8a2 2 0 0 1 0 2.8L8.8 18.8Z" />
      <path d="M13.8 6.6l3.6 3.6" />
    </>
  ),
  list: (
    <>
      <path d="M8.6 6.4h11.8M8.6 12h11.8M8.6 17.6h11.8" />
      <circle cx="4.4" cy="6.4" r="1.1" />
      <circle cx="4.4" cy="12" r="1.1" />
      <circle cx="4.4" cy="17.6" r="1.1" />
    </>
  ),
  cursor: <path d="M5.4 3.6 18.6 11l-5.8 1.6 3.4 6.4-2.6 1.4-3.4-6.4-4.8 3.6Z" />,
  grid: (
    <>
      <rect x="3.6" y="3.6" width="16.8" height="16.8" />
      <path d="M9.2 3.6v16.8M14.8 3.6v16.8M3.6 9.2h16.8M3.6 14.8h16.8" />
    </>
  ),
  zone: (
    <>
      <rect x="4" y="4" width="16" height="16" rx="1" />
      <path d="M4 12 12 4M4 20 20 4M12 20l8-8" />
    </>
  ),
  perimeter: <path d="M4 7.6 11 3.6l9 4.4-1.4 9.4L9.4 20.4 3.6 15Z" strokeDasharray="2.8 2.2" />,
  sector: (
    <>
      <path d="M3.6 6.4 12 3.6l8.4 3.6v10L12 20.4 3.6 17.2Z" />
      <path d="M12 3.6v16.8M3.6 11.8h16.8" />
    </>
  ),
  vertices: (
    <>
      <path d="M5.4 17.4 8.8 6.2l10 3.6-3.4 8.8Z" />
      <rect x="3.6" y="15.6" width="3.6" height="3.6" />
      <rect x="7" y="4.4" width="3.6" height="3.6" />
      <rect x="17" y="8" width="3.6" height="3.6" />
      <rect x="13.6" y="16.8" width="3.6" height="3.6" />
    </>
  ),
  fit: (
    <>
      <path d="M4 8.4V4h4.4M15.6 4H20v4.4M20 15.6V20h-4.4M8.4 20H4v-4.4" />
      <rect x="8.4" y="8.4" width="7.2" height="7.2" />
    </>
  ),
  fullscreen: <path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" />,
  undo: (
    <>
      <path d="M8.6 7.6H4.4V3.4" />
      <path d="M4.8 7.4A8 8 0 1 1 4 13" />
    </>
  ),
  trash: <path d="M4.6 6.6h14.8M9.4 6.6V4h5.2v2.6M6.4 6.6l1 13.8h9.2l1-13.8" />,
  filter: <path d="M4 5h16l-6.2 7.6V19l-3.6-1.8v-4.6Z" />,
  tag: (
    <>
      <path d="M3.6 12.4V4.4a.8.8 0 0 1 .8-.8h8l8 8-8.8 8.8Z" />
      <circle cx="8.2" cy="8.2" r="1.5" />
    </>
  ),
  cone: (
    <>
      <path d="M12 20.4 5.2 6.6a12 12 0 0 1 13.6 0Z" />
      <circle cx="12" cy="20.4" r="1.2" />
    </>
  ),
} as const;
